import { startChunkUpload, uploadChunkPart, completeChunkUpload } from 'services/site'

export const CHUNK_UPLOAD_THRESHOLD = 150 * 1024 * 1024 // 150MB
export const DEFAULT_CHUNK_SIZE = 20 * 1024 * 1024 // 20MB per chunk

const toFormData = ({ chunk, chunkNumber }) => {
  const formData = new FormData()
  formData.append('chunkNumber', String(chunkNumber))
  formData.append('chunk', chunk)
  return formData
}

const uploadSingleFileInChunks = async ({ file, config, onProgress }) => {
  const chunkSize = Math.max(DEFAULT_CHUNK_SIZE, Math.ceil(file.size / 10000))
  const totalChunks = Math.max(1, Math.ceil(file.size / chunkSize))

  const startResponse = await startChunkUpload(
    {
      filename: file.name,
      size: file.size,
      mimeType: file.type,
      totalChunks
    },
    config
  )

  const { uploadId } = startResponse.data
  const chunkProgress = new Array(totalChunks).fill(0)

  for (let index = 0; index < totalChunks; index += 1) {
    const start = index * chunkSize
    const end = Math.min(start + chunkSize, file.size)
    const chunk = file.slice(start, end)
    const chunkNumber = index + 1

    const formData = toFormData({ chunk, chunkNumber })

    await uploadChunkPart(uploadId, formData, config, (progressEvent) => {
      if (!onProgress || progressEvent?.loaded == null) return

      const previous = chunkProgress[index]
      const current = progressEvent.loaded
      const delta = Math.max(current - previous, 0)

      chunkProgress[index] = current
      onProgress(delta)
    })
  }

  const completionResponse = await completeChunkUpload(uploadId, {}, config)

  return {
    uploadId,
    originalFilename: file.name,
    mimeType: file.type,
    size: completionResponse?.data?.size || file.size
  }
}

export const handleChunkUploads = async ({ files, config, onProgress }) => {
  const chunkUploadReferences = []

  for (const file of files) {
    if (!file) continue

    const reference = await uploadSingleFileInChunks({
      file,
      config,
      onProgress
    })

    chunkUploadReferences.push(reference)
  }

  return chunkUploadReferences
}
